import { useEffect, useState } from "react";

const links = [
  { id: "hero", label: "00 / Index" },
  { id: "robocup-brazil", label: "01 / Brazil" },
  { id: "robocup-korea", label: "02 / Korea" },
  { id: "longboard", label: "03 / Longboard" },
  { id: "contact", label: "04 / Contact" },
];

export const Navbar = () => {
  const [active, setActive] = useState("hero");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px" }
    );
    links.forEach((l) => {
      const el = document.getElementById(l.id);
      if (el) observer.observe(el);
    });
    return () => {
      window.removeEventListener("scroll", onScroll);
      observer.disconnect();
    };
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-6 md:px-12 lg:px-16 h-16">
        <a
          href="#hero"
          data-testid="navbar-logo"
          className="font-mono-accent text-[11px] tracking-[0.3em] uppercase text-white hover:text-[#FF3B30] transition-colors"
        >
          N.BURGMAIER<span className="text-[#FF3B30]">_</span>
        </a>
        <ul className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <li key={l.id}>
              <a
                data-testid={`nav-link-${l.id}`}
                href={`#${l.id}`}
                className={`font-mono-accent text-[11px] tracking-[0.25em] uppercase transition-colors ${
                  active === l.id ? "text-white" : "text-white/40 hover:text-white"
                }`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
        <a
          href="#contact"
          data-testid="navbar-contact-btn"
          className="hidden md:inline-flex font-mono-accent text-[11px] tracking-[0.25em] uppercase text-black bg-white px-4 py-2 hover:bg-[#FF3B30] hover:text-white transition-colors"
        >
          Get in touch →
        </a>
        {/* Mobile menu indicator */}
        <a
          href="#contact"
          data-testid="navbar-contact-mobile"
          className="md:hidden font-mono-accent text-[10px] tracking-[0.25em] uppercase text-white border border-white/20 px-3 py-1.5"
        >
          Contact
        </a>
      </nav>
    </header>
  );
};
